import { gql } from '@apollo/client';

// Admin > Organisations (IB-1897): the current organisation's organisation-to-organisation relationships.
export const RELATIONSHIP_FIELDS = `
  id
  roles
  status
  startDate
  endDate
  source
  createdAt
  relatedOrganisation {
    id
    name
    type
    registrationNumber
    npoNumber
  }
`;

export const ORGANISATION_RELATIONSHIPS = gql`
  query OrganisationRelationships($input: OrganisationRelationshipsInput) {
    organisationRelationships: organisationRelationshipList(input: $input) {
      ${RELATIONSHIP_FIELDS}
    }
  }
`;

export const SEARCH_RELATABLE_ORGANISATIONS = gql`
  query SearchRelatableOrganisations($search: String!) {
    searchRelatableOrganisations(search: $search) {
      id
      name
      type
      registrationNumber
      npoNumber
    }
  }
`;
